const isAcquisitionSoftware = () => {
  if (process.env.IS_ACQUISITION_SOFTWARE) return true;
  return false;
};

export default isAcquisitionSoftware;
